"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "JsonPgHandler", {
    enumerable: true,
    get: function() {
        return JsonPgHandler;
    }
});
const _jsongeneralhandler = require("./json.general.handler");
const _sqlSanitize = require("~/helpers/sqlSanitize");
const _handlerUtils = require("~/db/field-handler/utils/handlerUtils");
const _ncError = require("~/helpers/ncError");
const appendIsNull = ({ qb, field, knex })=>{
    qb.where((nestedQb)=>{
        nestedQb.where(knex.raw("??::jsonb = '{}'::jsonb", [
            field
        ])).orWhere(knex.raw("??::jsonb = '[]'::jsonb", [
            field
        ])).orWhere(knex.raw("??::text = ''", [
            field
        ])).orWhereNull(field);
    });
};
const appendIsNotNull = ({ qb, field, knex })=>{
    qb.where((nestedQb)=>{
        nestedQb.whereNot(knex.raw("??::jsonb = '{}'::jsonb", [
            field
        ])).whereNot(knex.raw("??::jsonb = '[]'::jsonb", [
            field
        ])).whereNot(knex.raw("??::text = ''", [
            field
        ])).whereNotNull(field);
    });
};
let JsonPgHandler = class JsonPgHandler extends _jsongeneralhandler.JsonGeneralHandler {
    async filter(knex, filter, column, options) {
        const { alias } = options;
        const field = (0, _sqlSanitize.sanitize)(alias ? `${alias}.${column.column_name}` : column.column_name);
        let val = filter.value;
        return {
            rootApply: undefined,
            clause: (qb)=>{
                switch(filter.comparison_op){
                    case 'eq':
                        if (!(0, _handlerUtils.ncIsStringHasValue)(val)) {
                            appendIsNull({
                                qb,
                                field,
                                knex
                            });
                        } else {
                            const { jsonVal, isValidJson } = this.parseJsonValue(val);
                            if (isValidJson) {
                                qb.where(knex.raw('??::jsonb = ?::jsonb', [
                                    field,
                                    jsonVal
                                ]));
                            } else {
                                qb.where(knex.raw('??::text = ?', [
                                    field,
                                    jsonVal
                                ]));
                            }
                        }
                        break;
                    case 'neq':
                    case 'not':
                        if (!(0, _handlerUtils.ncIsStringHasValue)(val)) {
                            appendIsNotNull({
                                qb,
                                field,
                                knex
                            });
                        } else {
                            const { jsonVal, isValidJson } = this.parseJsonValue(val);
                            qb.where((nestedQb)=>{
                                if (isValidJson) {
                                    nestedQb.where(knex.raw('??::jsonb != ?::jsonb', [
                                        field,
                                        jsonVal
                                    ]));
                                } else {
                                    nestedQb.where(knex.raw('??::text != ?', [
                                        field,
                                        jsonVal
                                    ]));
                                }
                                nestedQb.orWhereNull(field);
                            });
                        }
                        break;
                    case 'like':
                        if (!(0, _handlerUtils.ncIsStringHasValue)(val)) {
                            appendIsNull({
                                qb,
                                knex,
                                field
                            });
                        } else {
                            val = `%${val}%`;
                            qb.where(knex.raw('??::text ilike ?', [
                                field,
                                val
                            ]));
                        }
                        break;
                    case 'nlike':
                        if (!(0, _handlerUtils.ncIsStringHasValue)(val)) {
                            appendIsNotNull({
                                qb,
                                knex,
                                field
                            });
                        } else {
                            val = `%${val}%`;
                            qb.where((nestedQb)=>{
                                nestedQb.where(knex.raw('??::text not ilike ?', [
                                    field,
                                    val
                                ]));
                                nestedQb.orWhereNull(field);
                            });
                        }
                        break;
                    case 'blank':
                        appendIsNull({
                            qb,
                            knex,
                            field
                        });
                        break;
                    case 'notblank':
                        appendIsNotNull({
                            qb,
                            knex,
                            field
                        });
                        break;
                    case 'is':
                        switch(val){
                            case 'blank':
                            case 'empty':
                                {
                                    appendIsNull({
                                        qb,
                                        knex,
                                        field
                                    });
                                    break;
                                }
                            case 'notblank':
                            case 'notempty':
                                {
                                    appendIsNotNull({
                                        qb,
                                        knex,
                                        field
                                    });
                                    break;
                                }
                        }
                        break;
                    case 'isnot':
                        switch(val){
                            case 'blank':
                            case 'empty':
                                {
                                    appendIsNotNull({
                                        qb,
                                        knex,
                                        field
                                    });
                                    break;
                                }
                            case 'notblank':
                            case 'notempty':
                                {
                                    appendIsNull({
                                        qb,
                                        knex,
                                        field
                                    });
                                    break;
                                }
                        }
                        break;
                    default:
                        _ncError.NcError._.unsupportedFilterOperation(filter.comparison_op);
                }
            }
        };
    }
};
